module.exports = __webpack_public_path__ + "img/navBg.e5f43fcb.png";